<template>
     <!--================ Pricing section start =================-->      
    <section class="section-margin">
      <div class="container">
        <div class="section-intro pb-85px text-center">
          <h2 class="section-intro__title">Choose Your Plan</h2>
          <p class="section-intro__subtitle">14 day free trial - cancel anytime - No credit card required</p>
        </div>

        <div class="row">
          <div class="col-md-6 col-lg-4 mb-4 mb-lg-0">
            <div class="card text-center card-pricing">
              <div class="card-pricing__header">
                <h4>Basic</h4>
                <p>Popular for startups</p>
                <h1 class="card-pricing__price"><span>$</span>29</h1> / month
                <br><p>Up to 50 customers</p>
              </div>
              <ul class="card-pricing__list">
                <li><i class="ti-check"></i>Retention Flow™</li>
                <li><i class="ti-check"></i>Cancelletion Checkout</li>
                <li><i class="ti-check"></i>Send messages / offers in app</li>
                <li><i class="ti-check"></i>Statistics & Graphs</li>
                <li><i class="ti-check"></i>Risk of churn monitoring</li>
                <li><i class="ti-check"></i>Screen Recordings</li>
                
                <li class="unvalid"><i class="ti-close"></i>Custom Integrations</li>
                <li class="unvalid"><i class="ti-close"></i>Dedicated Churn Expert</li>
                <li class="unvalid"><i class="ti-close"></i>On-premises solution</li>
                <li class="unvalid"><i class="ti-close"></i>Best in class enterprise support and SLAs</li>
              </ul>
              <div class="card-pricing__footer">
                <button class="button button-light" onclick="window.location.href = 'https://app.retainerdesk.com/#/register'">Try now</button>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-4 mb-4 mb-lg-0">
            <div class="card text-center card-pricing chosen">
              <div class="golden-most">Most popular</div>

              <div class="card-pricing__header">
                <h4>Retain Master</h4>
                <p>Recommended for most companies</p>
                <h1 class="card-pricing__price"><span>$</span>99</h1> / month
                <br><p>Up to 150 customers</p>
              </div>
              <ul class="card-pricing__list">
                <li><i class="ti-check"></i>Retention Flow™</li>
                <li><i class="ti-check"></i>Cancelletion Checkout</li>
                <li><i class="ti-check"></i>Send messages / offers in app</li>
                <li><i class="ti-check"></i>Statistics & Graphs</li>
                <li><i class="ti-check"></i>Risk of churn monitoring</li>
                <li><i class="ti-check"></i>Screen Recordings</li>
                <li><i class="ti-check"></i>Custom Integrations</li>
                <li><i class="ti-check"></i>Dedicated Churn Expert</li>
                <li class="unvalid"><i class="ti-close"></i>On-premises solution</li>
                <li class="unvalid"><i class="ti-close"></i>Best in class enterprise support and SLAs</li>

              </ul>
              <div class="card-pricing__footer">
                <button class="button button-light button-chosen" onclick="window.location.href = 'https://app.retainerdesk.com/#/register'">Try it free</button>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-4 mb-4 mb-lg-0">
            <div class="card text-center card-pricing">
              <div class="card-pricing__header">
                <h4>Zero churn</h4>
                <p>Recommended for big companies</p>
                <h1 class="card-pricing__price"><span>$</span>199</h1> / month
                <br><p>Unlimited amount of customers</p>

              </div>
              <ul class="card-pricing__list">
                <li><i class="ti-check"></i>Retention Flow™</li>
                <li><i class="ti-check"></i>Cancelletion Checkout</li>
                <li><i class="ti-check"></i>Send messages / offers in app</li>
                <li><i class="ti-check"></i>Statistics & Graphs</li>
                <li><i class="ti-check"></i>Risk of churn monitoring</li>
                <li><i class="ti-check"></i>Screen Recordings</li>
                <li><i class="ti-check"></i>Custom Integrations</li>
                <li><i class="ti-check"></i>Dedicated Churn Expert</li>
                <li><i class="ti-check"></i>On-premises solution</li>
                <li><i class="ti-check"></i>Best in class enterprise support and SLAs</li>

              </ul>
              <div class="card-pricing__footer">
                <button class="button button-light" onclick="window.location.href = 'https://app.retainerdesk.com/#/register'">Try it free</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--================ Pricing section end =================--> 
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

.golden-most {
  background-color:#ffbe00; 
  color:#464646; width:100px;     
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px; 
  left:50%; 
  transform: translateX(-50%); 
  position:absolute;
  cursor:pointer;
  font-size:12px;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,.2);

}
  .chosen {
    background: white;
    box-shadow: 0px 20px 25.5px 35.5px rgba(33, 20, 106, 0.1); 
  }

    .button-chosen{
      background:#1b75d3;
      color: white;
      border-color: #1b75d3;
    }

</style>